import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { useLabsStore, LabsStore } from "@stores/labsStore";
import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

export type UseLabsProps = {
};

export type UseLabs = (props: UseLabsProps) => {
  patientID: string,
  loading?: boolean;
  labs: any;
  noData: boolean
  count: number,
  dataCardId?: number;
  store?: LabsStore;
  refresh?: (x: any, y? :any) => void,
  patientId?: any
};

const defaultLabsValue: any[] = [];

export const useLabs: UseLabs = function (props) {
  const patientID = useMemo(() => {
    const cMember = membersService?.getCurrentMember;

    return cMember?.patient_id;
  }, [membersService?.getCurrentMember]);

  const [loading, setloading] = useState<boolean>(false)
  const store = useLabsStore(
    (store) => store
  );

  const [labs, setLabs, dataCardId, setdataCardId, count, setCount, noData, setnoData, patientId, setPatientId,] = useLabsStore((store) => [store.data, store.setdata, store.dataCardId, store.setdataCardId, store.count, store.setcount, store.noData, store.setnoData, store.patientId, store.setPatientId]);

  const refresh = React.useCallback((panelExpanded: any, params?: any) => {
    if (panelExpanded?.length > 0) {
    const page = params?.page ? params?.page : store.params.page;
    const filters = params && Object.hasOwn(params, 'filters') ? params?.filters : store.filters;
    const limit = params?.limit ? params?.limit : store.params.limit;
    const sortBy = params && Object.hasOwn(params, 'sortBy') ? params?.sortBy : store.params.sortBy;
    const sortType = params && Object.hasOwn(params, 'sortType') ? params?.sortType : store.params.sortType;
    const fetchRedValues = params  && Object.hasOwn(params, 'fetchRedValues') ? params?.fetchRedValues : store.fetchRedValues;

    setloading(true)
    memberDetailsService.fetchLabs(
      patientID,
      fetchRedValues, 
      page - 1,
      limit,
      sortBy,
      sortType,
      filters
    )
      .subscribe((response: any) => {
        let labs = response?.data?.data?.labs || []
        setLabs(labs)
        let count = response?.data?.data?.labs?.count || 0
        setCount(count)
        setPatientId(response?.data?.data?.patientID)
        setdataCardId(response?.data?.data?.datacardId)
        setloading(false)
      }, err => {
        setLabs([])
        setCount(0)
        setdataCardId(0)
        setloading(false)
      })
    } else console.log("Data card is available, no API call");
  }, [
    patientID,
    store?.params?.page,
    store.params.sortBy,
    store.params.sortType,
    store.params.limit,
    store.fetchRedValues,
    setLabs,
    setCount,
    setdataCardId,
    store.filters,
    setPatientId
  ])

  useEffect(
    () => {
      if (!store.fetchRedValues && (!store.filters || store.filters.length === 0) && count  === 0) {
        setnoData(true)
      } else {
        setnoData(false)
      }
    },
    [
      setnoData,
      store.fetchRedValues,
      store.filters,
      count
    ]
  )

  return {
    patientID,
    loading,
    labs,
    noData,
    count,
    dataCardId,
    store,
    refresh,
    patientId
  };
};

export const LabsContext = createContext<ReturnType<UseLabs>>({
  loading: false,
  patientID: '',
  labs: defaultLabsValue,
  noData: true,
  count: 0
});

export const LabsProvider: React.FC<UseLabsProps> = function ({ children, ...props }) {
  const labsValue = useLabs(props);

  return <LabsContext.Provider value={labsValue}>{children}</LabsContext.Provider>;
};

export const useLabsContext = () => useContext(LabsContext);
